import type { SandboxProviderCreds } from "@/frontend/types/sandbox-credentials";
import { SANDBOX_CREDENTIALS } from "@/frontend/constants/sandbox-credentials";

/** Returns the sandbox credential catalog for a FHIR source when the source's provider type and base URL match a known sandbox; otherwise `null`. Used by `OrganizationCard` to intercept the connect click and show the credential picker before hand-off to the provider's OAuth login. */
export function findSandboxCredentials(source: { type: string | null; fhirBaseUrl: string }): SandboxProviderCreds | null {
  if (!source.type) return null;
  return SANDBOX_CREDENTIALS.find(
    (e) => e.providerType === source.type && e.matchFhirBaseUrl(source.fhirBaseUrl),
  ) ?? null;
}
